import {getDeviceLockMethod} from '@web/actions/device'
import makeSlice from '@web/slices/orderProcessor/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {
                    data: {verificationKey},
                } = payload

                state.verificationKey = verificationKey
            })
            .addCase(getDeviceLockMethod.fulfilled, (state, {payload}) => {
                state.deviceLockType = payload
            })
    },
})

export default slice.reducer
